import { ticketClient } from "@/api/index";
import { GetUrgeEfficiencyReq } from "@/pbjs/xcommon/ticket_pb";
import { setCommon, setPage, handleResponse, errorMsg } from "@/utils/request";
import { setMetaData } from "@/utils";
// lee 绩效接口参数
interface Options {
  UserName?: string;
  ItemId: number; // 工单分类
  // Userid: number; // 用户id
  employeeID?: string;
  UserGroupId?: string; // 角色
  Timerange: string;
  RangeType: number;
  pageIndex: number;
  pageSize: number;
  Statstype: number;
  Hour?: number;
  Email?: string;
}
export function getUrgeEfficiency(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new GetUrgeEfficiencyReq();
      request.setCommonin(setCommon());
      request.setItemid(arg.ItemId); // 工单分类
      // request.setUserid(arg.employeeID); // 用户id
      if (arg.employeeID) {
        request.setEmployeeid(arg.employeeID); // 角色
      }
      if (arg.UserGroupId) {
        request.setUsergroupid(Number(arg.UserGroupId)); // 角色
      }
      if (arg.UserName) {
        request.setUsername("" + arg.UserName); // 角色
      }
      request.setTimerange(arg.Timerange);
      // request.setRangetype(arg.RangeType);
      request.setStatstype(arg.Statstype);
      if (arg.Statstype == 1 || arg.Statstype == 3) {
        request.setHour(arg.Hour);
      }
      if (arg.Email) {
        request.setEmail(arg.Email);
      }
      request.setPagein(setPage(arg.pageIndex, arg.pageSize));
      // setRank
      let _res = await ticketClient.getUrgeEfficiency(
        request,
        setMetaData(),
        (err: any, response: any) => {
          if (response) {
            const res: any = response.toObject();
            resolve(res);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      response.loading = false;
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}
export function getUrgeEfficiencyExcel(arg: Options, obj: any) {
  return new Promise((resolve, reject) => {
    (async () => {
      let request: any = new GetUrgeEfficiencyReq();
      request.setCommonin(setCommon());
      request.setItemid(arg.ItemId); // 工单分类
      // request.setUserid(arg.employeeID); // 用户id
      if (arg.employeeID) {
        request.setEmployeeid(arg.employeeID); // 角色
      }
      if (arg.UserGroupId) {
        request.setUsergroupid(Number(arg.UserGroupId)); // 角色
      }
      if (arg.UserName) {
        request.setUsername("" + arg.UserName); // 角色
      }
      request.setTimerange(arg.Timerange);
      // request.setRangetype(arg.RangeType);
      request.setStatstype(arg.Statstype);
      if (arg.Statstype == 1 || arg.Statstype == 3) {
        request.setHour(arg.Hour);
      }
      if (arg.Email) {
        request.setEmail(arg.Email);
      }
      request.setPagein(setPage(arg.pageIndex, arg.pageSize));
      // setRank
      let _res = await ticketClient.getUrgeEfficiencyExcel(
        request,
        setMetaData(),
        (err: any, response: any) => {
          if (response) {
            resolve(response);
          }
          if (err) {
            reject(err);
          }
        }
      );
    })();
  })
    .then((response: any) => {
      response.loading = false;
      handleResponse(response, null);
      return response;
    })
    .catch((err: any) => {
      errorMsg(err);
    });
}
